module.exports = __webpack_public_path__ + "static/img/rejected_icon.9061a6b4.png";